function i(e) {
  return new Promise((t, n) => {
    e.oncomplete = e.onsuccess = () => t(e.result), e.onabort = e.onerror = () => n(e.error);
  });
}
function d(e, t) {
  const n = indexedDB.open(e);
  n.onupgradeneeded = () => n.result.createObjectStore(t);
  const r = i(n);
  return (o, c) => r.then((l) => c(l.transaction(t, o).objectStore(t)));
}
let a;
function u() {
  return a || (a = d("keyval-store", "keyval")), a;
}
function s(e, t = u()) {
  return t("readonly", (n) => i(n.get(e)));
}
function f(e, t, n = u()) {
  return n("readwrite", (r) => (r.put(t, e), i(r.transaction)));
}
function p(e, t = u()) {
  return t("readwrite", (n) => (n.delete(e), i(n.transaction)));
}
function b(e = u()) {
  return e("readwrite", (t) => (t.clear(), i(t.transaction)));
}
class w {
  init(t, n) {
    const r = d(t, `v${n}`);
    return r("readwrite", () => {
    }), {
      getItem: (o, c) => s(o, r) ?? (c !== Object(c) ? c : void 0),
      setItem: (o, c) => f(o, c, r),
      removeItem: (o) => p(o, r),
      clear: () => b(r)
    };
  }
}
const S = new w(), m = S.init;
export {
  S as KV,
  m as init
};
